var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeatingSolutions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Line_Expand",
    "data-name": "Line Expand",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25,37V9A9,9,0,0,0,7,9V37a15,15,0,1,0,18,0ZM16,62A13,13,0,0,1,8.572,38.33,1,1,0,0,0,9,37.51V9A7,7,0,0,1,23,9V37.51a1,1,0,0,0,.428.82A13,13,0,0,1,16,62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21,39.2V9A5,5,0,0,0,11,9V39.2a11,11,0,1,0,10,0ZM13,9a3,3,0,0,1,6,0V22H13Zm3,49a9,9,0,0,1-3.6-17.251,1,1,0,0,0,.6-.916V24h6V39.833a1,1,0,0,0,.6.916A9,9,0,0,1,16,58Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32,34H29a1,1,0,0,0,0,2h3a1,1,0,0,0,0-2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34,30H29a1,1,0,0,0,0,2h5a1,1,0,0,0,0-2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29,28h3a1,1,0,0,0,0-2H29a1,1,0,0,0,0,2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34,22H29a1,1,0,0,0,0,2h5a1,1,0,0,0,0-2Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29,20h3a1,1,0,0,0,0-2H29a1,1,0,0,0,0,2Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34,14H29a1,1,0,0,0,0,2h5a1,1,0,0,0,0-2Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29,12h3a1,1,0,0,0,0-2H29a1,1,0,0,0,0,2Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M34,6H29a1,1,0,0,0,0,2h5a1,1,0,0,0,0-2Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M50,0A13,13,0,1,0,63,13,13.015,13.015,0,0,0,50,0Zm0,24A11,11,0,1,1,61,13,11.013,11.013,0,0,1,50,24Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5,11A1.5,1.5,0,0,1,48,12.5a1,1,0,0,0,2,0,3.5,3.5,0,0,0-7,0v5a3.5,3.5,0,0,0,7,0,1,1,0,0,0-2,0,1.5,1.5,0,0,1-3,0v-5A1.5,1.5,0,0,1,46.5,11Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53,4.5a3,3,0,1,0,3,3A3,3,0,0,0,53,4.5Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,53,8.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatingSolutions);
export default __webpack_public_path__ + "static/media/HeatingSolutions.cd6a376aa5ff6da4014201fa1168a38f.svg";
export { ForwardRef as ReactComponent };